import { render } from "./danyuanList.vue?vue&type=template&id=4fff90b6&scoped=true"
import script from "./danyuanList.vue?vue&type=script&lang=js"
export * from "./danyuanList.vue?vue&type=script&lang=js"

import "./danyuanList.vue?vue&type=style&index=0&id=4fff90b6&lang=scss&scoped=true"

import exportComponent from "G:\\web2\\豪哥\\盘龙山陵园\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fff90b6"]])

export default __exports__